import React, { Suspense, lazy } from 'react';
import { Route } from 'react-router-dom';
import ApplicationSkeleton from '~/components/ApplicationSkeleton';

const AsyncUserCreate = lazy(() => import('~/containers/UserCreate'));

export default [
  <Route path="/users/create">
    <Suspense fallback={<ApplicationSkeleton />}>
      <AsyncUserCreate />
    </Suspense>
  </Route>,
];
